import {Action} from '@ngrx/store';
import {BacnetPoint, PointValue} from '../../shared/models/point';
import { DeviceId } from 'src/shared/models/device';

export const POINTS_DISCOVERED = '[Points] discovered device points';
export const POINT_VALUES_RECEIVED = '[Points] received point values';

export class PointsDiscoveredAction implements Action {
  readonly type = POINTS_DISCOVERED;

  constructor(public deviceId: DeviceId, public points: BacnetPoint[]) {
  }
}

export class PointsValuesReceived implements Action {
  readonly type = POINT_VALUES_RECEIVED;

  constructor(public pointValues: PointValue[]) {
  }
}

export type Actions = PointsDiscoveredAction | PointsValuesReceived
